import { discountCodeClient, slotClient } from 'clients';
import { Changes } from 'components/RenterList/EditRenterForm';
import { SlotInterface } from 'types';

export async function editRental(slot: SlotInterface, changes: Changes) {
    if (changes.discountCode) {
        await discountCodeClient.applyDiscountCode(slot.pk, changes.discountCode);
    }

    if (changes.plate) {
        // Route plate edits through the slot so the car is owned by the slot's
        // renter, not the owner/admin making the request. Do NOT POST cars/ here —
        // that endpoint is self-serve and stamps owner = authenticated actor. EXP-955.
        await slotClient.updateCarsListOfRental(slot.uuid, {
            cars_list: [
                {
                    plate: changes.plate,
                    state: changes.state || '',
                    country: changes.country || '',
                },
            ],
        });
    }
}
